import { useTranslation } from 'react-i18next';
import mockup from "../assets/mobile_mockup.png";

const About = () => {
    const { t } = useTranslation();
    
    return (
        <section id='about' className="container min-h-fit text-3xl py-20 flex flex-col md:flex-row flex-wrap items-center justify-center font-bold">
            <div className='flex flex-1 items-center justify-center'>
                <img src={mockup} className="w-[800px] min-w-[300px] max-w-full" alt="Mockup" />
            </div>
            <div className='flex flex-1 flex-col justify-center text-center md:text-left min-w-[300px]'>
                <h3 className='text-[40px] py-10 font-primary'>{t('about.whatIsSpotCard')}</h3>
                <p className='text-[20px] font-secondary font-normal'>
                    {t('about.whatIsDescription')}
                </p>
                <h3 className='text-[40px] pb-10 pt-14 font-primary leading-tight'>
                    {t('about.howHelpsBusiness')}
                </h3>
                <p className='text-[20px] font-secondary font-normal'>
                    {t('about.howHelpsDescription')}
                </p>
            </div>
        </section>
    );
};

export default About;